import React, { FC } from 'react';

interface Props {
  title?: string;
  subTitle?: string;
  className?: string;
  classes?: {
    childDivClass?: string;
    pClass?: string;
  };
  style?: React.CSSProperties;
}

const MainHCell: FC<Props> = ({ title, subTitle }) => {
  return (
    <div className='flex flex-col gap-1 items-center py-6 bg-dropDownMenuBg border-b border-white/60 justify-center'>
      <p className='xl:text-lg text-base text-white font-semibold text-center'>
        {title}
      </p>
      <p className='xl:text-base text-base text-white font-normal text-center'>
        {subTitle}
      </p>
    </div>
  );
};

export default MainHCell;
